// Shared mime predicates for Spark Guide content. Every component that classifies a
// guide's document type must use these — divergent local heuristics let a parent dialog
// and the child editor disagree about the same document.
// Callers decide how to treat a missing mime: the wizard and editor default an
// empty mime to text (an authorable guide), previews treat it as not-text.
export const isTextMimeType = (mimeType: string): boolean =>
	mimeType.startsWith("text/") || mimeType === "application/markdown" || mimeType.endsWith("/markdown");

export const isPdfMimeType = (mimeType: string): boolean => mimeType === "application/pdf";

export const isWordMimeType = (mimeType: string): boolean =>
	mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || mimeType === "application/msword";
